module.exports = __webpack_public_path__ + "img/empty-drafts.e63fe707.svg";